export default __webpack_public_path__ + "static/member7-6c56a76ead5e3c5a7da33a46f8357099.jpg";